export const en = {
    conference: 'Conference',
    online: 'Online',
};
